<ng-container *transloco="let t;">
<ng-scrollbar autoHeightDisabled="false" visibility="hover" class="sidebar-content-scrollbar">
  <div>  
    <div class="media-list document-links">
      <div class="media links-box mb-2 px-1">
        <div class="media-body">
          <h6 class="fw-bold mb-25 d-flex justify-content-start">
            <i class="me-50 feather mt-25 icon-link" width="13" height="13"></i> 
            <span class="sidebar-parties-name">{{ roleDetail?.roleable?.visible_name ?? roleDetail?.roleable.name }}</span>
          </h6>
  
          <div class="senderContactInfo-btn">
            <button
              *ngIf="!downloading && canDownloadDocument$"
              type="button"
              class="btn btn-icon btn-warning"
              placement="auto"
              [autoClose]="true"
              triggers="hover"
              [ngbTooltip]='t("Document tab download pdf text (Document tab) - Download PDF")'
              container="body"
              (click)="downloadPdf()"
            >
              <span [data-feather]="'download'" [size]="13"></span>
            </button>
              <span *ngIf="downloading" class="spinner-border spinner-border-sm ms-50"></span>
            <button
              type="button"
              class="btn btn-icon btn-warning hidden"
              placement="auto"
              [autoClose]="true"
              triggers="hover"
              [ngbTooltip]='t("Document tab print pdf text (Document tab) - Print PDF")'
              container="body"
            >
              <span [data-feather]="'printer'" [size]="13"></span>
            </button>
          </div>
        </div>
      </div>
      <!-- <div class="media links-box mb-2 px-1">
        <div class="media-body">
          <div>
            <h6 class="fw-bold d-block text-nowrap mb-0 sidebar-parties-name">
              <i [data-feather]="'link'" [size]="13"></i>
              rbhomeworkoutguide2020-3.pdf
            </h6>
            <small class="document-link-attachmentText"
              >Uploaded by Asad outlook Shah 333 2023-07-10 09:16</small
            >
          </div>
  
          <div class="senderContactInfo-btn remove-uploadAttachmentBtn">
            <button
              type="button"
              class="btn btn-icon btn-warning"
              placement="left"
              [autoClose]="true"
              triggers="hover"
              ngbTooltip="Delete"
              container="body"
            >
              <span [data-feather]="'trash'" [size]="13"></span>
            </button>
          </div>
        </div>
      </div>
      <div class="media links-box mb-2 px-1">
        <div class="media-body">
          <div>
            <h6 class="fw-bold d-block text-nowrap mb-0 sidebar-parties-name">
              <i [data-feather]="'link'" [size]="13"></i>
              rbhomeworkoutguide2020-3.pdf
            </h6>
            <small class="document-link-attachmentText"
              >Uploaded by Asad outlook Shah 333 2023-07-10 09:16</small
            >
          </div>
  
          <div class="senderContactInfo-btn remove-uploadAttachmentBtn">
            <button
              type="button"
              class="btn btn-icon btn-warning"
              placement="left"
              [autoClose]="true"
              triggers="hover"
              ngbTooltip="Delete"
              container="body"
            >
              <span [data-feather]="'trash'" [size]="13"></span>
            </button>
          </div>
        </div>
      </div> -->
    </div>

    
    <div class="media links-box mb-2 px-1 flex-column position-relative">
        <div class="media-body d-flex justify-content-between align-items-center w-100 py-1 border-bottom" *ngFor="let file of uploadedFiles">
          <div>
            <h6 class="fw-bold mb-25 d-flex justify-content-start">
              <i class="me-50 feather mt-25 icon-link" width="13" height="13"></i> 
              <span class="sidebar-parties-name">{{ file.file_name }}</span>
            </h6>
            <p class="mb-0 font-small-3 ps-1 ms-50">{{t("Document tab uploaded by text (Document tab) - Uploaded by")}} {{ file.uploaded_by }}</p>
            <p class="mb-0 font-small-3 ps-1 ms-50">{{ file.updated_at | dateFormat | async }}</p>
          </div>
  
          <div class="senderContactInfo-btn m-0">
            <button
              *ngIf="downloadingFileId !== file.id"
              type="button"
              class="btn btn-icon btn-warning"
              placement="auto"
              [autoClose]="true"
              triggers="hover"
              [ngbTooltip]='t("Document tab download uploaded file button tooltip (Document tab) - Download file")'
              container="body"
              (click)="downloadUploadedFile(file.file_path, file.file_name, file.id)"
            >
              <span [data-feather]="'download'" [size]="13"></span>
            </button>
            <span *ngIf="downloadingFileId === file.id" class="spinner-border spinner-border-sm ms-50"></span>
          </div>
        </div>
      </div>
      
    </div>
  </ng-scrollbar>
  <div *ngIf="roleDetail?.template_settings?.allow_upload_file">
    <input
      type="file"
      #fileInput
      (change)="onFileSelected($event)"
      accept=".jpeg,.png,.jpg,.csv,.doc,.docx,.pdf,.ppt,.pptx,.txt"
      style="display: none"
    />
    <button
      type="button"
      class="btn btn-block btn-success mx-1 signingDocumentlinks-upload-files"
      (click)="fileInput.click()"
    >
      <span *ngIf="uploadFileLoader" class="spinner-border spinner-border-sm me-1"></span>
      {{ t("Document tab upload file button text (Document tab) - Upload file") }}
    </button>
  </div>
</ng-container>